import styled from "styled-components";
import bg1 from "./assets/Graphics/bg1.png";

// import img1 from "./assets/img1.webp";

export const Container = styled.div`
  margin: 0 clamp(1px, 5vw, 100px);
`;

export const Landing = styled.div`
  /* margin: 0 clamp(1px, 5vw, 220px); */
  /* background-color: aliceblue; */
  text-align: center;
  display: flex;
  flex-direction: column;
  height: calc(100vh - 160px);
  h1 {
    text-transform: uppercase;
    font-size: clamp(36px, 5vw, 100px);
    span {
      display: block;
      text-transform: capitalize;
      font-size: clamp(36px, 5vw, 100px);
      font-weight: 100;
    }
  }
  .text {
    margin-top: auto;
    margin-bottom: auto;
  }
`;

export const Hero = styled.div`
  display: flex;
  align-items: stretch; // Ensures both Content and ImageContainer have the same height
  justify-content: space-between;
  /* padding: 1rem; */
  background-color: #fff;
  border-radius: 10px;
  height: 100%;
  /* margin: 0 clamp(1px, 5vw, 100px); */
  /* max-width: 900px; */
  /* margin: 0 auto; */
  @media (max-width: 768px) {
    /* padding: 1.5rem; */
    flex-direction: column;
  }
`;

export const Content = styled.div`
  flex: 1 1 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-right: 1rem;
  @media (max-width: 768px) {
    padding: 1rem 0;
    padding-right: 0;
    /* margin-bottom: 1rem; */
    order: 2; /* Ensure content appears after the image on mobile */
  }
`;

export const Title = styled.h1`
  font-size: 2rem;
  font-weight: bold;
  color: #273743;
`;

export const Description = styled.p`
  font-size: 1rem;
  color: #4a4a4a;
  margin: 1rem 0;
  line-height: 1.4;

  ul {
    list-style: none;
    margin-top: 1rem;
    padding-left: 0;
    /* border: 1px solid #e0e0e0; */
    /* border-radius: 8px; */
    /* background-color: #f9f9f9; */
    padding: 1rem 0;
  }

  li {
    /* padding: 0.5rem 0; */
    display: flex;
    align-items: center;
    /* font-size: 1.1rem; */
  }

  li span {
    margin-left: 10px;
    color: #333;
    font-weight: bold;
  }

  li:hover {
    background-color: #f0f0f0;
  }
`;

export const ImageContainer = styled.div`
  flex: 1 1 35%;
  position: relative;
  object-fit: contain;
  justify-content: center;
  align-self: center;
  img {
    /* padding: 5px; */
    border-radius: 10px;
    width: 100%;
    height: auto;
  }

  @media (max-width: 768px) {
    width: 70%;
    /* min-height: 300px !important; */

    img {
      padding-top: 0;
      /* position: absolute; */
      /* top: 0; */
    }
  }
`;

export const IconContainer = styled.div`
  flex: 0 0 auto;
  margin-right: 20px;

  img {
    width: 10em;
    height: auto;
  }
`;

export const H3 = styled.h3`
  font-family: ${(props) =>
    props.lang === "fa" ? "Tanha, sans-serif" : "Purisa, sans-serif"};
  font-size: clamp(22px, 2.2vw, 10em);
  /* font-weight: bold; */
  text-align: center;
  /* text-transform: uppercase; */
  /* width: fit-content; */
  letter-spacing: -1px;
  width: 100%;
  /* padding-top: 1em; */
  padding: 0.3em;
  margin: 1.5em 0;

  background-image: url(${bg1});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  /* background-color: red; */
`;
